import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, serverTimestamp } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyC5TyXj3GyOj42plq7oicA0D8ejOihj2Ww',
  authDomain: 'mnwblog.firebaseapp.com',
  databaseURL: 'https://mnwblog-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'mnwblog',
  storageBucket: 'mnwblog.firebasestorage.app',
  messagingSenderId: '342137735284',
  appId: '1:342137735284:web:c8c86c90573a21feca6921'
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export { serverTimestamp };
